// Main product slider
const productSliderSettings = {
  loop: false,
  spaceBetween: 10,
  allowTouchMove: true,
  pagination: {
    el: '.product__media-pagination',
    clickable: true
  },
  breakpoints: {
    769: {
      spaceBetween: 20,
      // allowTouchMove: false,
      centeredSlides: false
    }
  }
}

let productSlider = '';

function initSlider() {
  productSlider = new Swiper('.product__media-list', productSliderSettings);

  // Sync slider with thumbnails
  productSlider.on('slideChange', slider => {
    let idx = slider.realIndex;
    const activeThumb = document.querySelector('.product__media-thumbnail-item.active');
    const newThumb = document.querySelector(`.product__media-thumbnail-item[data-index="${idx}"]`);
    
    activeThumb.classList.remove('active');
    newThumb.classList.add('active');
  });
  
  // Sync thumbnails with slider
  const thumbnails = document.querySelectorAll('.product__media-thumbnail-item');
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', event => {
      let idx = Number(event.currentTarget.dataset.index);
  
      productSlider.slideTo(idx);
    });
  });
}

initSlider();


// Handle Navigation Tabs
const tabs = document.querySelectorAll('.product-tab');

tabs.forEach(tab => {
  tab.addEventListener('click', event => {
    const dataTab = tab.dataset.tab;

    document.querySelector('.product-tab.active').classList.remove('active');
    document.querySelector(`.product-tab[data-tab="${dataTab}"]`).classList.add('active');

    document.querySelector('.product-tabs__content.active').classList.remove('active');
    document.querySelector(`.product-tabs__content[data-tab="${dataTab}"]`).classList.add('active');
  });
});

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    console.log('aaaa')
    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
});

// Subscription images
const subscriptionButtons = document.querySelectorAll('.product-form__sub-item')
if (subscriptionButtons) {
  subscriptionButtons.forEach(button => {
    button.addEventListener('click', event => {
      const set = button.id
      const subImages = document.querySelectorAll(`#${set}-images .product__option-media-item`)

      // Media notice text comes from the product metafield custom.slider_notice
      const mediaList = document.querySelector('.product__media-list')
      const sliderNotice = mediaList ? (mediaList.dataset.sliderNotice || '') : ''
      const noticeHTML = sliderNotice ? `<div class="product__media-notice bg-16 m-bg-12"><div class="product__media-notice-dot"></div> ${sliderNotice}</div>` : ''

      if (subImages) {
        const thumbs =  document.querySelector('.product__media-thumbnails')
        const images = document.querySelector('.product__media-list .swiper-wrapper')
        let newThumbs = ''
        let newImages = ''

        productSlider.destroy()

        subImages.forEach((image, i) => {
          const thumbImageUrl = image.dataset.mobileUrl
          const imageUrl = image.dataset.url
            
          newThumbs = newThumbs + `
            <li>
              <button class="product__media-thumbnail-item ${ i == 0 && 'active' }" data-media-id="template--21792488751425-${i}" data-index="${i}">
                <div class="aspect-ratio img-fill " style="max-width: 100%; width: 100%;">
                  <img data-src="${thumbImageUrl}" data-widths="[200,300,400,600,800,900,1000,1200]" data-sizes="auto" alt="${set}" data-media-id="${i}" sizes="48px" src="${thumbImageUrl}">
                </div>
              </button>
            </li>
          `
          console.log(set == 'one-time' && i == 0)
          newImages = newImages + `
            <li class="product__media-item swiper-slide" data-media-id="template--21792488751425__main-${i}" role="group">
              <div class="product__media">
                <img src="${imageUrl}" alt="${set}" class="img-fill">
              </div>
              ${set != 'one-time' && i == 0 ? noticeHTML : '' }
           </li>
          `
        })

        thumbs.innerHTML = newThumbs
        images.innerHTML = newImages

        initSlider()
      }
    })
  })
}